<template>
    <div style="position:relative;width:100%;height:100%;">
        <nav class="agx-navbar-shop agx-theme-bg navbar"
            :class="{ 'navbar-fixed-top': navBarBottom != true, 'navbar-fixed-bottom': navBarBottom }" style="z-index:100;">

            <div class="agx-navbar-wrapper" style="position:relative; display: flex; align-items: center;" :style="{ 'margin-left': contentMarginLeft + 'px' }">
                <div style="flex: 1;">

                    <div class="navbar-header">
                        <!--<div v-if="showNavBack" class="navbar-toggle" style="display: inline-block; float: left; background: rgba(128,128,128,0.7);" @click="$router.go(-1)">
                            <span class="icon-bar" style="margin-left: 0px; transform: rotate(-30deg);"></span>
                            <span class="icon-bar" style="height:2px;background:transparent;"></span>
                            <span class="icon-bar" style="margin-left:0px;transform: rotate(30deg);"></span>
                        </div>-->
                        <button type="button" :style="{ display: navIn ? 'none' : 'block' }" style="float: left;"
                            class="navbar-toggle" @click="toggleNav">
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>

                        <slot name="topNavBrand"></slot>

                    </div>
                    <div class="agx-nav-bar navbar-collapse collapse">
                        <slot name="topNavMenus">

                        </slot>
                    </div>
                </div>
                <slot name="topNavRight"></slot>
            </div>
        </nav>
        <nav @click="toggleNav" class="navbar sidebar agx-theme-bg" role="navigation"
            :style="{ 'margin-left': sideMenuMarginLeft + 'px', 'width': menuWidth + 'px' }"
            style="border-right: 1px solid gray; border-radius: 0px; position: fixed;height: 100%; float: left; z-index: 8000; margin-bottom: 0px; ">
            <div class="container-fluid" style="height:100%;overflow-y:auto;overflow-x:hidden;">
                <button type="button" style="float: left; display: block; height: 34px;" class="navbar-toggle">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>

                <!-- Collect the nav links, forms, and other content for toggling -->
                <div style="clear: both;">
                    <slot name="sideMenu"></slot>
                </div>

            </div>
        </nav>

        <div class="main" style="position: relative;height: 100%;"
            :style="{ 'margin-left': contentMarginLeft + 'px', 'padding-top': navBarBottom === true ? '0px' : '50px', 'padding-bottom': navBarBottom === true ? '50px' : '0px' }">
            <modal-relative :show="navIn" @clicked="toggleNav"></modal-relative>
            <div ref="columnsWrap" style="height: 100%;">

                <div style=" position: relative;height: 100%; float: left;"
                    :style="{ 'width': (showLeftCol ? leftColWidth + '%' : '0%') }">
                    <slot name="leftBody" v-if="showLeftCol"></slot>
                    <div v-if="showLeftCol"
                        style="position:absolute;top:0;right:-4px;width:8px;height:100%;cursor:col-resize;z-index:10;touch-action:none;"
                        @mousedown.prevent="startLeftBodyResize"
                        @touchstart.prevent="startLeftBodyResize"></div>
                </div>
                <div class="scrolling-container" ref="rightBody"
                    style=" position: relative;height: 100%; float: right;overflow-y: auto;"
                    :style="{ 'width': (showLeftCol ? (100 - leftColWidth) + '%' : '100%') }">
                    <div>
                        <slot name="topBody"></slot>
                    </div>
                    <slot name="body"></slot>
                </div>
            </div>
        </div>

        <div
            style="position: fixed; bottom: 6px; left: 10px; text-align: center; z-index: 100; background: rgb(128, 128, 128,0.8);height:44px;padding:2px;">
            <div style="color:white;">
                <span class="btn glyphicon glyphicon-arrow-left" @click="$router.go(-1)"></span>
                <template>
                    <slot name="bottomNavCenter"></slot>
                </template>
                <span class="btn glyphicon glyphicon-arrow-right" @click="$router.go(+1)"></span>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from '../base/Loading.vue';
import ModalRelative from '../base/ModalRelative.vue';

export default {
    components: {
        Loading: Loading,
        ModalRelative: ModalRelative
    },
    props: {

    },
    computed: {
        navBarBottom: function () {
            return this.$store.getters.navBarBottom;
        },
        showNavBack: function () {
            return this.$store.getters.showNavBack;
        },
        sideMenuMarginLeft: function () {
            return this.navIn === true ? 0 : -this.menuWidth;
        },
        contentMarginLeft: function () {
            return this.navIn === true ? this.menuWidth : 0;
        },
        isLargerThanSM: function () {
            return this.windowWidth > 768;
        },
        showLeftCol: function () {
            return this.isLargerThanSM && !this.isIndexPage;
        }
    },
        data: function () {
            return {
                menuWidth: 250,
                navIn: false,
                windowWidth: window.innerWidth,
                isIndexPage: false,
                leftColWidth: 30,
                isResizingLeftBody: false
            }
        },
    methods: {
        toggleNav: function () {
            this.navIn = !this.navIn;
        },
        toggleMenu: function () {
            this.showMenu = !this.showMenu;
        },
        windowWidthUpdate: function () {
            this.windowWidth = window.innerWidth;
        },
        indexPageCheck: function () {
            this.isIndexPage = this.$router.currentRoute.name === 'index';
        },
        startLeftBodyResize: function (e) {
            this.isResizingLeftBody = true;
            document.body.style.cursor = 'col-resize';
            document.body.style.userSelect = 'none';
            document.addEventListener('mousemove', this.leftBodyResize);
            document.addEventListener('mouseup', this.stopLeftBodyResize);
            document.addEventListener('touchmove', this.leftBodyResize, { passive: false });
            document.addEventListener('touchend', this.stopLeftBodyResize);
            this.leftBodyResize(e);
        },
        leftBodyResize: function (e) {
            if (!this.isResizingLeftBody || !this.$refs.columnsWrap) {
                return;
            }
            var clientX = e.clientX;
            if (e.touches && e.touches.length) {
                clientX = e.touches[0].clientX;
                e.preventDefault();
            }
            var rect = this.$refs.columnsWrap.getBoundingClientRect();
            var pct = ((clientX - rect.left) / rect.width) * 100;
            pct = Math.max(18, Math.min(60, pct));
            this.leftColWidth = pct;
        },
        stopLeftBodyResize: function () {
            this.isResizingLeftBody = false;
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            document.removeEventListener('mousemove', this.leftBodyResize);
            document.removeEventListener('mouseup', this.stopLeftBodyResize);
            document.removeEventListener('touchmove', this.leftBodyResize);
            document.removeEventListener('touchend', this.stopLeftBodyResize);
        },
        fireLayoutChange: function () {
            this.$emit("onLayoutChange", { display: { leftBody: this.showLeftCol } });
        },
    },
    created: function () {
        console.log("LayoutV3 created");
        window.addEventListener('resize', this.windowWidthUpdate);
        this.indexPageCheck();
    },
    mounted: function () {
        console.log("LayoutV3 mounted");
        this.fireLayoutChange();
    },
    destroyed: function () {
        window.removeEventListener("resize", this.windowWidthUpdate);
        this.stopLeftBodyResize();
    },
    watch: {
        '$route'() {
            this.indexPageCheck();
            var $rightBody = this.$refs.rightBody;
            $rightBody.scrollTop = 0;
        },
        showLeftCol: function () {
            console.log("layoutV3, change detected");
            this.fireLayoutChange();
        }
    }
}
</script>
